import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { links } from "../utils/linkData";
import { getAuthToken } from "../utils/token";
import ServiceList from "./ServiceList";
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [appointment, setAppointment] = useState(false);
  const token = getAuthToken();
  const navigate = useNavigate();

  // toggle language
  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "hi" : "en";
    changeLanguage(newLang);
  };

  const appointmentHandler = () => {
    setAppointment(!appointment);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setAppointment(false);
  };

  return (
    <>
      <nav className="h-24 md:h-36 bg-custom-maroon p-4 border-b border-custom-yellow-dark">
        <div className="h-full flex justify-between items-center">
          {/* Logo */}
          <div className="flex justify-center w-full md:w-2/12">
            <Link to="/" onClick={handleLinkClick}>
              <img src={logo} alt="logo" className="w-40 md:w-full" />
            </Link>
          </div>

          {/* Desktop Navigation Links */}
          <div className="h-full hidden md:flex justify-center items-center space-x-4 w-10/12">
            {links.map((link, i) => (
              <Link
                to={link.url}
                key={i}
                className="text-white group py-16 hover:text-custom-yellow"
                onClick={handleLinkClick}
              >
                <span className="border-e-2 pr-4 group-last:border-e-0 border-custom-yellow">
                  {t(link.title)}
                </span>
                <ul className="hidden group-hover:flex items-end absolute w-auto md:w-full md:left-0 bg-custom-maroon p-2 mt-[calc(60px)] z-50">
                  <div className="flex justify-end mr-4 gap-4 w-7/12">
                    {link.images.map((image, i) => (
                      <img
                        src={image.img}
                        key={i}
                        alt="nav_imgs"
                        className="w-56 h-56 rounded-sm"
                      />
                    ))}
                  </div>
                  <div className="flex flex-col h-60 w-5/12">
                    {link.additionalData.map((sublink, j) => (
                      <Link
                        to={sublink.url}
                        key={j}
                        className="text-white hover:underline underline-offset-8 decoration-custom-yellow-dark rounded-sm border-maroon-50 p-2"
                        onClick={handleLinkClick}
                      >
                        {t(sublink.title)}
                      </Link>
                    ))}
                  </div>
                </ul>
              </Link>
            ))}

            {/* Projects Button */}
            <Link
              to="/projects"
              onClick={handleLinkClick}
              className="text-white py-16 hover:text-custom-yellow"
            >
              <span className="pr-4 border-custom-yellow">
                {t("navbar.projects", "Projects")}
              </span>
            </Link>
          </div>

          {/* Book Appointment + Language Switch */}
          <div className="hidden relative w-2/12 md:flex gap-3 justify-center">
            <div className="bg-custom-yellow flex justify-center items-center text-white p-1 rounded-md">
              <button
                onClick={toggleLanguage}
                className="flex w-full bg-custom-maroon text-white p-3 rounded-md active:scale-95"
              >
                {i18n.language === "en" ? "हिन्दी" : "English"}
              </button>
            </div>
            <button
              className="bg-custom-yellow text-white p-1 rounded-md"
              onClick={appointmentHandler}
            >
              <span className="flex w-full bg-custom-maroon text-white p-3 rounded-md active:scale-95">
                Book
              </span>
            </button>

            <AnimatePresence>
              {appointment && <ServiceList onClose={appointmentHandler} />}
            </AnimatePresence>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className="flex justify-center">
        {isOpen && (
          <div className="md:hidden flex flex-col gap-3 bg-custom-maroon p-4 border-b border-custom-yellow-dark w-[calc(90vw)]">
            {links.map((link, i) => (
              <Link
                to={link.url}
                key={i}
                className="text-white group hover:text-custom-yellow pr-4"
                onClick={toggleMenu}
              >
                {t(link.title)}
                <ul className="hidden group-hover:flex flex-col absolute w-auto bg-custom-maroon p-2 z-50">
                  {link.additionalData.map((sublink, j) => (
                    <Link
                      to={sublink.url}
                      onClick={toggleMenu}
                      key={j}
                      className="text-white hover:bg-custom-yellow rounded-sm border-maroon-50 p-2"
                    >
                      {t(sublink.title)}
                    </Link>
                  ))}
                </ul>
              </Link>
            ))}

            {/* Projects Button for Mobile */}
            <Link
              to="/projects"
              onClick={toggleMenu}
              className="text-white hover:text-custom-yellow self-start"
            >
              {t("navbar.projects", "Projects")}
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
